import globals from '../../globals';
import { _sendWithAxios, _sendWithAxiosBlob } from '../api'
 
const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;


// BUYER

export const cadastrarBuyer = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/cadastrar-buyer`, 'POST', data);
}

export const detalheEmpresaBuyer = async (idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/detalhes-buyer/${idEmpresa}`, 'GET');
}

export const empresasBuyer = async (pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/empresas-buyer/${pagina}/10`, 'GET');
}

export const empresasBuyerPorFiltro = async (filtro, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/empresas-buyer/${filtro}/${pagina}/10`, 'GET');
}

export const atualizarBuyer = async (idBuyer, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/atualizar-buyer/${idBuyer}`, 'PUT', data);
}

export const ativarBuyer = async (idBuyer) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/ativar-buyer/${idBuyer}`, 'PUT');
}

export const inativarBuyer = async (idBuyer) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/inativar-buyer/${idBuyer}`, 'PUT');
}

export const gerarExelBuyers = async () => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}Buyer/gerar-exel-buyers`, 'GET')
}

// CDLoja

export const cadastrarCd = async (idBuyer, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoLojaBuyer/cadastrar-cdloja-buyer/${idBuyer}`, 'POST', data);
}

export const listarCds = async (idBuyer, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoLojaBuyer/listar-cdloja-buyer/${idBuyer}/${pagina}/10`, 'GET');
}

export const ListarCdsPorFiltro = async (idBuyer, filtro, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoLojaBuyer/empresas-cdsloja-buyer/${idBuyer}/${filtro}/${pagina}/10`, 'GET');
}

export const atualizarCd = async (idCd, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoLojaBuyer/atualizar-cdloja-buyer/${idCd}`, 'PUT', data);
}

export const ativarCd = async (idCd) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoLojaBuyer/ativar-cdloja-buyer/${idCd}`, 'PUT');
}

export const inativarCd = async (idCd) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoLojaBuyer/inativar-cdloja-buyer/${idCd}`, 'PUT');
}

export const detalhesCdBuyer = async (idCd) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoLojaBuyer/detalhes-cdloja-buyer/${idCd}`, 'GET');
}

export const gerarExelCds = async (idBuyer) => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}CentroDistribuicaoLojaBuyer/gerar-exel-cdsloja-buyer/${idBuyer}`);
} 

// LOJA

export const cadastrarLoja = async (idBuyer, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LojaBuyer/cadastrar-loja-buyer/${idBuyer}`, 'POST', data);
}

export const listarLojas = async (idBuyer, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LojaBuyer/listar-loja-buyer/${idBuyer}/${pagina}/10`, 'GET');
}

export const ListarLojasPorFiltro = async (idBuyer, filtro, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LojaBuyer/empresas-lojas-buyer/${idBuyer}/${filtro}/${pagina}/10`, 'GET');
}

export const atualizarLoja = async (idLoja, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LojaBuyer/atualizar-loja-buyer/${idLoja}`, 'PUT', data);
}

export const ativarLoja = async (idLoja) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LojaBuyer/ativar-loja-buyer/${idLoja}`, 'PUT');
}

export const inativarLoja = async (idLoja) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LojaBuyer/inativar-loja-buyer/${idLoja}`, 'PUT');
}

export const dealhesLojaBuyer = async (idLoja) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LojaBuyer/detalhes-loja-buyer/${idLoja}`, 'GET');
}

export const gerarExelLojas = async (idBuyer) => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}LojaBuyer/gerar-exel-lojas-buyers/${idBuyer}`);
}

// USUARIO

export const listarUsuariosBuyer = async (idBuyer, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}UsuarioBuyer/listar-usuarios-buyer/${idBuyer}/${pagina}/10`, 'GET');
}

export const ligarPorFiltroUsuariosBuyer = async (idBuyer, filtro, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}UsuarioBuyer/listar-usuarios-buyer/${filtro}/${idBuyer}/${pagina}/10`, 'GET');
}

export const gerarExcelUsuarios = async (idBuyer) => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}UsuarioBuyer/extrair-usuarios-buyer/${idBuyer}`);
}

export const cadastrarUsuarioBuyer = async (data, idBuyer) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/cadastrar-usuario/Buyer/${idBuyer}`, 'POST', data)
}

export const atualizarUsuarioBuyer = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/atualizar-usuario/`, 'PUT', data)
}

export const detalheUsuarioBuyer = async (idUsuario) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/detalhe-usuario/${idUsuario}`, 'GET')
}

export const ativarUsuarioBuyer = async (idUsuario) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/ativar-usuario/${idUsuario}`, 'PUT');
}

export const inativarUsuarioBuyer = async (idUsuario) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/inativar-usuario/${idUsuario}`, 'PUT')
}

// CATEGORIA PRODUTO
export const listarCategoriaProdutoBuyer = async (idBuyer, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/categoria-produto-buyer/${idBuyer}/${pagina}/10`, 'GET');
}

export const listarCategorias = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/listar-categorias`, 'GET');
}

export const cadastrarCategoriaProdutoBuyer = async (idBuyer, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/categoria-produto-buyer/${idBuyer}`, 'POST', data);
}

export const removerCategoriaProdutoBBuyer = async (idCategoriaProdutoBuyer) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Buyer/categoria-produto-buyer/${idCategoriaProdutoBuyer}`, 'DELETE');
}

// REMUNERAÇÃO GREENER BUYER
export const idRemuneracaoGreenerBuyer = async (idBuyer) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersBuyer/identificador-remuneracao-buyer/${idBuyer}`, 'GET');
}

export const detalhesRemuneracaoGreenerBuyer = async (idRemuneracao) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersBuyer/detalhes-remuneracao-buyer/${idRemuneracao}`, 'GET');
}

export const atualizarRemuneracaoGreenerBuyer = async (idRemuneracao, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersBuyer/atualizar-remuneracao-buyer/${idRemuneracao}`, 'PUT', data);
}

export const cadastrarRemuneracaoGreenerBuyer = async (idBuyer, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersBuyer/cadastrar-remuneracao-buyer/${idBuyer}`, 'POST', data);
}

export const obterTermoBuyer = async (idBuyer, linkFront) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}TermoAceiteBuyer/obter-termo-buyer/${idBuyer}?linkfront=${linkFront}`, 'GET');
}

export const obterTermoBuyerCadastro = async (idBuyer) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}TermoAceiteBuyer/termo-buyer/${idBuyer}`, 'GET');
}




